import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { getAdminRiskLevels } from '@api/adminLookups';
import { IRiskLevel } from '@interfaces/riskLevels';

export const handleGetAdminRiskLevels = createAsyncThunk<
  AxiosResponse<IRiskLevel[]>,
  {
    programCode: number;
  }
>('getAdminRiskLevels', ({ programCode }) => getAdminRiskLevels(programCode));
